import createTargetComponent from '@adobe/target-react-component';
import React, { Fragment } from 'react';
import classNames from 'classnames';
import If from '../If/If';
import styles from './AppTitle.module.scss';

const Target = createTargetComponent(React);

interface AppTitleProps {
  className?: string;
  mboxTitle?: string;
  mboxSubtitle?: string;
  title: string | JSX.Element;
  subtitle?: string | JSX.Element;
}

const AppTitle: React.FC<AppTitleProps> = ({
  className = '',
  mboxTitle = '',
  mboxSubtitle,
  title,
  subtitle,
}) => (
  <div className={classNames(styles['app-title'], className)}>
    {mboxTitle ? (
      <Fragment>
        <Target
          data-at_property="eb143c91-3999-92fd-60bc-2dca0b84690f"
          data-mbox={mboxTitle}
        >
          <h2>{title}</h2>
        </Target>
        <Target
          data-at_property="eb143c91-3999-92fd-60bc-2dca0b84690f"
          data-mbox={mboxSubtitle}
        >
          <If test={!!subtitle}>
            <h4>{subtitle}</h4>
          </If>
        </Target>
      </Fragment>
    ) : (
      <Fragment>
        <h2>{title}</h2>
        <If test={!!subtitle}>
          <h4>{subtitle}</h4>
        </If>
      </Fragment>
    )}
  </div>
);

export default AppTitle;
